// fill timeseries data with missing days
// expect newest to oldest ordering
const fillTimeSeriesData = (
    data = [],
    moment = null,
    limit = 60,
    startDate = null,
    endDate = null,
) => {
    if (!Array.isArray(data) || !data.length || !moment) return [];

    const maxData = [...data].slice(-limit);
    const timeline = [];
    startDate = moment(startDate);
    endDate = moment(endDate);

    // fallback limit if data spans a long period instead of last 365 days
    let currentRun = 0;

    // streamline start and end dates
    const oldestDateInData = moment(maxData[0]?.t);
    const newestDateInData = moment(maxData[maxData.length - 1]?.t);

    if (startDate && startDate.isAfter(oldestDateInData)) {
        maxData.unshift({ t: startDate.format("YYYY-MM-DD"), y: 0 });
    }

    if (endDate && newestDateInData.isAfter(endDate)) {
        maxData.push({ t: endDate.format("YYYY-MM-DD"), y: 0 });
    }

    maxData.forEach((entry, index) => {
        let currentDate = moment(entry.t);
        timeline.push(entry);

        const nextEntry = maxData[index + 1];
        if (!nextEntry || currentRun >= limit) return;

        const nextEntryDate = moment(nextEntry.t);

        while (currentRun < limit && currentDate.subtract(1, "d").isAfter(nextEntryDate)) {
            timeline.push({ t: currentDate.format("YYYY-MM-DD"), y: 0 });
            currentRun += 1;
        }

        currentRun += 1;
    });

    return Object.freeze(timeline);
};

export default fillTimeSeriesData;
